<template>
  <div class='lt-fyf-progress-bar'>
    <ProgressBarItem
      v-for="(question, index) in sceneQuestions"
      :key="index"
      :status='status[question.statusKey]'
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields([
      'ui.sceneQuestions',
      'scene.status',
    ]),
  },
};
</script>

<style lang='scss'>

.lt-fyf-progress-bar {
  margin: 1.5rem;
  display: flex;
  align-content: stretch;
  height: 20px;
  display: none;
  &.lt-fyf-progress-bar--large {
    margin: 0 1.5rem;
    height: 40px;
  }
}

</style>
